import { configureStore } from '@reduxjs/toolkit';

import userReducer from './slices/user-slice';
import basketReducer from './slices/basket-slice';
import bookingReducer from './slices/booking-slice';
import languageReducer from './slices/language-slice';
import paymentPlanReducer from './slices/payment-plan-slice';
import errorState from './slices/snackbar-slice';
import dualOccupantReducer from './slices/dual-occupant-slice';

const store = configureStore({
    reducer: {
        user: userReducer,
        basket: basketReducer,
        booking: bookingReducer,
        language: languageReducer,
        paymentPlan: paymentPlanReducer,
        error: errorState,
        dualOccupant: dualOccupantReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
